<template>
  <div>
    <nav-bar
      @getLatLong="onLocationClick"
      @isDelivery="isDeliverySet"
      :settingData="$auth.setting"
    ></nav-bar>

    <!-- Loading State -->
    <section class="resturant-main tab-content header-top" v-if="isLoading">
      <div class="slider-home-top">
        <div class="custom-container">
          <div class="slider__shimmer__grid my-5">
            <skeleton-loader-vue
              v-for="i in 3"
              :key="'slider-shimmer-' + i"
              type="rect"
              height="250px"
              width="420px"
              class="menu-cat-img"
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- Brand Shimmer -->
            <skeleton-loader-vue
              type="rect"
              width="200px"
              height="20px"
              class="brand-name mb-4"
            />
            <skeleton-loader-vue
              type="circle"
              width="120px"
              height="120px"
              class="brand-logo"
            />
            <!-- Categories/Menus/Top Selling Shimmer -->
            <div
              v-for="section in ['Categories', 'Menus', 'Top Selling']"
              :key="section"
            >
              <skeleton-loader-vue
                type="rect"
                width="200px"
                height="20px"
                class="brand-name mb-4"
              />
              <div class="category__grid mb-5">
                <skeleton-loader-vue
                  v-for="i in 8"
                  :key="`${section}-shimmer-${i}`"
                  type="rect"
                  height="200px"
                  width="100%"
                  class="skeleton-item"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Service Not Available State -->
    <section
      class="resturant-main tab-content header-top"
      v-if="isServiceNotAvailable"
    >
      <div class="home-res-not-found mt-5">
        <div class="nostr-img-cls">
          <img src="@/assets/images/no_store.png" alt="Service not available" />
          <div class="no-txt-fnd">{{ $t("Service not available") }}</div>
          <span>{{
            $t(
              "Service not available in this area. Please change location and try again."
            )
          }}</span>
        </div>
      </div>
    </section>

    <!-- Content State -->
    <section class="resturant-main tab-content header-top" v-else>
      <div class="slider-home-top">
        <div class="custom-container">
          <home-slider
            :banners="banners"
            @isDeliveryHome="isDeliverySet"
            @getMobileLatLong="onLocationClick"
            @brand-banner-clicked="brandBannerClicked"
          />
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <home-title v-if="brandTitle" :title="brandTitle" subtitle="" />
            <brand :brands="brands" />
            <home-category
              v-if="showCategory"
              :categories="categories"
              :restaurant="restaurant"
            />
            <home-menu
              v-if="showMenus"
              :menus="menus"
              :restaurant="restaurant"
              :latitude="filter.lat"
              :longitude="filter.lng"
            />
            <home-top-selling-items :restaurant="restaurant" />
          </div>
          <div id="touchFooter"></div>
        </div>
      </div>
    </section>

    <!-- Business Closed Modal -->
    <div
      class="modal fade order-placed"
      id="businessClosed"
      tabindex="-1"
      aria-labelledby="businessClosedLabel"
      aria-hidden="true"
      ref="businessClosedModal"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content business-modal-contnt">
          <div class="modal-body text-center">
            <p class="business-txt">{{ notAvailableReason }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Alert Modal -->
    <alert-modal
      v-if="isAlert"
      :DisplayAlertData="AlertData"
      @modalClose="onModalCloseFun"
    />

    <!-- WhatsApp Support -->
    <a
      v-if="whatsappSupport"
      :href="'https://wa.me/' + whatsappSupport"
      class="float"
      target="_blank"
    >
      <img
        class="wp-button"
        src="@/assets/images/whatsapp-icon.png"
        alt="WhatsApp Support"
      />
    </a>
    <footer-comp />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import HomeSlider from "@/components/HomeSlider.vue";
import HomeTitle from "@/components/HomeTitle.vue";
import NavBar from "@/components/NavBar.vue";
import AlertModal from "@/components/AlertModal.vue";
import Footer from "@/components/Footer.vue";
import Brand from "@/components/Brand.vue";
import HomeCategory from "@/components/HomeCategory.vue";
import HomeMenu from "@/components/HomeMenu.vue";
import HomeTopSellingItems from "@/components/HomeTopSellingItems.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import Setting from "@/apis/setting";
import Banner from "@/apis/banner";
import vendor from "@/apis/vendor";
import moment from "moment";

export default {
  name: "Home",
  components: {
    HomeSlider,
    HomeTitle,
    NavBar,
    AlertModal,
    "footer-comp": Footer,
    Brand,
    HomeCategory,
    HomeMenu,
    HomeTopSellingItems,
    "skeleton-loader-vue": VueSkeletonLoader,
  },
  data: function () {
    return {
      filter: {
        lat: "",
        lng: "",
        city: "",
        state: "",
        is_pickup_delivery: "",
      },
      whatsappSupport: "",
      isAlert: false,
      AlertData: {},
      isLoading: true,
      isServiceNotAvailable: false,
      restaurant: {},
      brand_id: "",
      categoryCount: null,
      showCategory: false,
      categories: [],
      showMenus: false,
      menus: [],
      brands: [],
      banners: [],
    };
  },
  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),

    brandTitle() {
      var setting = this.$auth.setting;
      if (
        setting &&
        setting.terminology &&
        setting.terminology.length > 0 &&
        setting.terminology[0] &&
        setting.terminology[0].brand_text
      ) {
        return setting.terminology[0].brand_text;
      }
      return "";
    },

    notAvailableReason() {
      var setting = this.$auth.setting;
      if (setting && setting.not_available_reason) {
        return setting.not_available_reason;
      }
      return "Not available";
    },

    isProductTypeValid() {
      var setting = this.$auth.setting;
      return setting && setting.product_type && setting.product_type.id === 1;
    },
  },

  mounted() {
    console.log(this.$auth.setting);
    if (this.$auth && this.$auth.user) {
      this.getCurrentOrdersRating();
    }
    setTimeout(
      function () {
        this.initializeComponent();
      }.bind(this),
      1000
    );
    this.$root.$on("a-store-set-event", this.aFarStoreEventHandler);
  },

  beforeDestroy() {
    this.$root.$off("a-store-set-event", this.aFarStoreEventHandler);
  },

  methods: {
    ...mapActions("order", ["getCurrentOrdersWithratingsList", "deliveryZone"]),
    ...mapMutations("product", ["clearCartItems"]),
    ...mapMutations("restaurant", [
      "getRestaurantListMutation",
      "getBusinessCateMutation",
    ]),

    initializeComponent() {
      this.isLoading = true;
      if (this.$auth.setting.is_deliveryzone_area == '1' || this.$auth.setting.is_deliveryzone_area == 1) {
        this.isLoading = false;
        this.isServiceNotAvailable = true;
      } else {
        this.isServiceNotAvailable = false;
        this.initializeWhatsappSupport();
        this.checkBusinessHours();
        this.initializeFilterCoordinates();
        this.getBanner();
        this.getBrands();
        this.setupInfiniteScroll();
        this.isLoading = false;
      }
    },

    initializeWhatsappSupport() {
      var setting = this.$auth.setting;
      if (!setting || !setting.support_field || !setting.support_field.length) {
        return;
      }
      var whatsappElement = setting.support_field.find(function (el) {
        return el.whatsapp;
      });
      if (whatsappElement && setting.country_code) {
        this.whatsappSupport = setting.country_code + whatsappElement.whatsapp;
      }
    },

    checkBusinessHours() {
      var setting = this.$auth.setting;
      if (setting && setting.is_system_available === "0") {
        window.$(this.$refs.businessClosedModal).modal("show");
        return;
      }
      this.checkBusinessTimings();
    },

    checkBusinessTimings() {
      var setting = this.$auth.setting;
      if (!setting || !setting.system_start_time || !setting.system_end_time) {
        return;
      }
      var format = "HH:mm:ss";
      var currentTime = moment().format(format);
      var startTime = moment(setting.system_start_time).format(format);
      var endTime =
        moment(setting.system_end_time).format(format) === "00:00:00"
          ? "23:59:00"
          : moment(setting.system_end_time).format(format);

      var isWithinBusinessHours = moment(currentTime, format).isBetween(
        moment(startTime, format),
        moment(endTime, format)
      );

      if (
        !isWithinBusinessHours &&
        setting.schedule_order_after_business_hours_text
      ) {
        this.showAlert(setting.schedule_order_after_business_hours_text);
      }
    },

    getBanner() {
      return Banner.getBanner({
        vendor_id: 40818,
        latitude: this.filter.lat,
        longitude: this.filter.lng,
        status: 1,
      }).then(
        function (response) {
          if (response && response.data && response.data.code === 200) {
            this.banners = response.data.Result;
          }
        }.bind(this)
      );
    },

    getBrands() {
      if (
        this.$auth &&
        this.$auth.setting &&
        this.$auth.setting.is_single_restaurant === "No"
      ) {
        vendor
          .getBrandList({
            vendor_id: 40818,
            latitude: this.filter.lat,
            longitude: this.filter.lng,
            is_langauge: this.$store.state.lang.locale,
          })
          .then((response) => {
            if (response && response.data && response.data.code === 200) {
              Setting.deliveryZoneSettings({
                vendor_id: 40818,
                is_langauge: this.$store.state.lang.locale,
                lat: this.filter.lat,
                lan: this.filter.lng,
              }).then((zoneResp) => {
                if (
                  zoneResp &&
                  zoneResp.data &&
                  zoneResp.data.Result &&
                  zoneResp.data.Result.is_delivery_zone_available === "Yes"
                ) {
                  this.brands = response.data.Result;
                  this.brandFetched();
                } else {
                  console.log("service not available ");
                  this.isServiceNotAvailable = true;
                }
                this.isLoading = false;
              });
            } else {
              this.isServiceNotAvailable = true;
              this.isLoading = false;
            }
          })
          .catch(() => {
            this.isServiceNotAvailable = true;
            this.isLoading = false;
          });
      } else {
        this.isServiceNotAvailable = true;
        this.isLoading = false;
      }
    },

    getNearestRestaurant() {
      vendor
        .getNearestNestaurant({
          vendor_id: 40818,
          latitude: this.filter.lat,
          longitude: this.filter.lng,
          brand_id: this.brand_id,
          is_language: this.$store.state.lang.locale,
        })
        .then((response) => {
          // console.log("getNearestNestaurant", response)
          if (response && response.data && response.data.code === 200) {
            this.restaurant = response.data.Result[0];
            localStorage.setItem('nearestRestaurant', JSON.stringify(this.restaurant));

            this.categoryCount = this.restaurant.menu_category_count;
            if (this.categoryCount > 0) {
              this.getCategory();
            } else {
              this.getMenus();
            }
          } else {
            this.isServiceNotAvailable = true;
            this.isLoading = false;
          }
        });
    },

    getCategory() {
      vendor
        .getRestaurantMenuCategory({
          vendor_id: 40818,
          brand_id: this.restaurant.brand_id,
          restaurant_id: this.restaurant.restaurant_id,
          is_langauge: this.$store.state.lang.locale,
        })
        .then((response) => {
          if (response && response.data && response.data.code === 200) {
            this.categories = response.data.Result;
            this.showCategory = true;
          }
          this.isLoading = false;
        });
    },

    getMenus() {
      vendor
        .getRestaurantMenuWiseCategory({
          vendor_id: 40818,
          brand_id: this.restaurant.brand_id,
          restaurant_id: this.restaurant.restaurant_id,
          is_langauge: this.$store.state.lang.locale,
          latitude: this.filter.lat,
          longitude: this.filter.lng,
          starttime: "",
        })
        .then((response) => {
          if (response && response.status === 200) {
            this.menus = response.data.Result;
            this.showMenus = true;
          }
          this.isLoading = false;
        });
    },

    brandBannerClicked(value) {
      vendor
        .getNearestNestaurant({
          vendor_id: 40818,
          latitude: this.filter.lat,
          longitude: this.filter.lng,
          brand_id: value,
          is_language: this.$store.state.lang.locale,
        })
        .then((response) => {
          if (response.data.code == 200) {
            const redirectRestaurant = response.data.Result[0];
            if (redirectRestaurant) {
              this.$router.push({
                name: "vendor",
                params: { restaurant_name: redirectRestaurant.slug },
              });
            }
          }
        });
    },

    showAlert(message) {
      this.AlertData = {
        displayMessage: message,
        isSetClass: "schedule-modal",
      };
      this.isAlert = true;
    },

    initializeFilterCoordinates() {
      this.filter.lat = this.getStoredCoordinate("latitude");
      this.filter.lng = this.getStoredCoordinate("longitude");
    },

    getStoredCoordinate(key) {
      var value = localStorage.getItem(key);
      return value && value !== "" ? parseFloat(value) : "";
    },

    setupInfiniteScroll() {
      if (!this.isProductTypeValid || this.$route.name !== "home") return;

      var containerEl = document.getElementById("touchFooter");
      if (containerEl) {
        var observer = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              this.handleScrollIntersection();
            }
          }.bind(this)
        );
        observer.observe(containerEl);
      }
    },

    onModalCloseFun() {
      this.isAlert = false;
    },

    isDeliverySet(value) {
      this.filter.is_pickup_delivery = value;
      this.clearCartItems();
      this.getRestaurantListMutation([]);
      this.getBusinessCateMutation([]);
      this.isLoading = true;
      this.initializeComponent();
    },

    onLocationClick(value) {
      this.setFilterCoordinates(value);
      if (value.onclick === "yes") {
        this.checkDeliveryZone();
      }
    },

    setFilterCoordinates: function (value) {
      this.filter.lat = value.lat
        ? parseFloat(value.lat)
        : this.getStoredCoordinate("latitude");
      this.filter.lng = value.lng
        ? parseFloat(value.lng)
        : this.getStoredCoordinate("longitude");
      this.filter.city = value.city || "";
      this.filter.state = value.state || "";
      this.initializeComponent();
    },

    checkDeliveryZone() {
      this.deliveryZone({
        vendor_id: this.$auth.getVendorId(),
        is_language: this.$store.state.lang.locale,
        latitude: this.filter.lat,
        longitude: this.filter.lng,
        order_web: window.location.hostname,
      })
        .then((data) => {
          if (data && data.settings) {
            this.handleDeliveryZoneResponse(data);
          }
        })
        .catch((error) => {
          console.error("Delivery zone check failed:", error);
          this.isServiceNotAvailable = true;
          this.isLoading = false;
        });
    },

    handleDeliveryZoneResponse(data) {
      var isAvailable = data.settings.is_delivery_zone_available === "Yes";
      this.filter_on_off = isAvailable;
      localStorage.setItem(
        "is_delivery_zone_available",
        data.settings.is_delivery_zone_available
      );
      if (!isAvailable && data.settings.not_available_delivery_zone_reason) {
        this.$toasted.error(data.settings.not_available_delivery_zone_reason);
        this.isServiceNotAvailable = true;
      }
    },

    getCurrentOrdersRating() {
      if (!this.$auth || !this.$auth.user) return;
      this.getCurrentOrdersWithratingsList({
        vendor_id: this.$auth.getVendorId(),
        is_language: this.$store.state.lang.locale,
        user_id: this.$auth.user.user_id,
        skip: 0,
        totalrecord: 20,
      }).then(function (data) {
        if (data && data.code === 200 && data.Result) {
          this.ordersList = data.Result.map(function (order) {
            return {
              estminut: this.calculateEstimatedMinutes(order),
              delayMsg: this.checkOrderDelay(order),
            };
          });
        }
      });
    },

    calculateEstimatedMinutes(order) {
      if (!order) return "0";
      var timeMs =
        (order.eta_delivery_times || order.delivery_times || 0) * 1000;
      return moment.utc(timeMs).format("m") || "0";
    },

    checkOrderDelay(order) {
      return order && order.eta
        ? moment(order.eta).diff(moment(), "minutes") > 0
        : false;
    },

    aFarStoreEventHandler() {
      this.getRestaurantListMutation([]);
      this.getBusinessCateMutation([]);
      this.clearCartItems();
      this.isLoading = true;
    },

    brandFetched() {
      if (this.brands.length) {
        this.brand_id = this.brands[0].id;
        this.getNearestRestaurant();
      } else {
        this.isServiceNotAvailable = true;
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.slider__shimmer__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.skel-img-cls {
  width: 120px;
  height: 120px;
  margin-right: 7px;
  border-radius: 5px !important;
}
.business-txt {
  margin: 85px;
}
</style>